const INITIAL_STATE = { 
    registro: {}, 
    modoTela: 'lista', 
	aguardando: false,
    lista: [], 
    listaUnidade: [],
    listaProduto: [],
    listaTanque: [],
    listaMotorista: [],
    listaVeiculo: [],
    listaDistribuidora: [],
    listaPedido: [],
    listaTipo: [
        { id: 1, valor: 'Compra' },
        { id: 2, valor: 'Retorno do Cliente' },
        { id: 3, valor: 'Quebra de Estoque' }
    ],
    listaEstoqueBase: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'ESTOQUE_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};
        
        case 'ESTOQUE_SET_AGUARDANDO':
            return { ...state,
                aguardando: action.payload
            };

        case 'ESTOQUE_LISTADO':
            return { ...state, lista: action.payload.data };

        case 'ESTOQUE_BASE_LISTADO':
            return { ...state, listaEstoqueBase: action.payload.data };

        case 'ESTOQUE_PEDIDO_SELECT_LISTADO':
            return { ...state, listaPedido: action.payload.data };

        case 'ESTOQUE_UNIDADE_SELECT_LISTADO':
			return {
				...state,
				listaUnidade: action.payload.data
            };

        case 'ESTOQUE_PRODUTO_SELECT_LISTADO':
			return {
				...state,
				listaProduto: action.payload.data
            };

        case 'ESTOQUE_TANQUE_SELECT_LISTADO':
			return {
				...state,
				listaTanque: action.payload.data
            };

        case 'ESTOQUE_MOTORISTA_SELECT_LISTADO':
			return {
				...state,
				listaMotorista: action.payload.data
            };

        case 'ESTOQUE_VEICULO_SELECT_LISTADO':
			return {
				...state,
				listaVeiculo: action.payload.data
            };

        case 'ESTOQUE_DISTRIBUIDORA_SELECT_LISTADO':
			return {
				...state,
				listaDistribuidora: action.payload.data
            };
                      
        default:
            return state;
    }
}
